import { StaffScope, VenueSystemRole } from './enums';
import { CurrentUserVenue, UserVenue, VenueWithDetails } from './types/auth.types';

export const transformUserVenue = (
  venueWithDetails: VenueWithDetails,
  currentUserVenue?: CurrentUserVenue,
): UserVenue => {
  return {
    id: venueWithDetails.organisationId,
    name: venueWithDetails.organisationName as string,
    type: venueWithDetails.organisationType,
    nationalAssociationSubType: venueWithDetails.nationalAssociationSubType,
    parentOrganisation: venueWithDetails.parentOrganisation,
    hierarchy: venueWithDetails.hierarchy,
    venueSystemRoles: currentUserVenue?.VenueSystemRoles ?? VenueSystemRole.NONE,
    scope: currentUserVenue?.Scope ?? StaffScope.NONE,
    tenantSettings: {
      enableNationalAdminAccess: currentUserVenue?.Settings?.EnableNationalAdminAccess ?? false,
      enableRegionalAdminAccess: currentUserVenue?.Settings?.EnableRegionalAdminAccess ?? false,
    },
  };
};
